import { Badge, Typography } from "@mui/material";
import "./customBadge.scss"

interface CustomBadgeProps {
    className: string,
    content: string,
    sx?: React.CSSProperties
}
const CustomBadge = ({ className, content, sx }: CustomBadgeProps)=>{
    return (
        <Badge className={className} sx={{ paddingX: 2, paddingY: 1, minWidth: { xs: "80%", md: "40%" } , justifyContent: "center", ...sx }}>
            <Typography fontSize={12}>{content}</Typography>
        </Badge>
    )
}

export default CustomBadge;